import React, { memo, useCallback, useState } from 'react'
import PageVisibility from 'react-page-visibility'
import moment from 'moment'
import LOG from '../logging/Logger'

const VISIBLE_CALLBACK_AFTER_IDLE_MINS = 10
const IDLE_CALLBACK_AFTER_IDLE_MINS = 10

export default memo(
  ({
    children,
    whenVisibleCallback,
    whenIdleCallback,
    triggerWhenVisibleAfterIdleMins = VISIBLE_CALLBACK_AFTER_IDLE_MINS,
    triggerAfterIdleMins = IDLE_CALLBACK_AFTER_IDLE_MINS
  }) => {
    const [invisibleStart, setInvisibleStart] = useState(moment())
    const [idleTimeout, setIdleTimeout] = useState()

    const handleVisibilityChange = useCallback(
      isVisible => {
        LOG.debug('Visibility Change: ' + isVisible)

        if (!isVisible) {
          setInvisibleStart(moment())
        } else if (idleTimeout) {
          clearTimeout(idleTimeout)
        }

        if (isVisible && whenVisibleCallback) {
          LOG.debug(
            'Visible after: ' + moment().diff(invisibleStart, 'minutes')
          )
          if (
            moment().diff(invisibleStart, 'minutes') >=
            triggerWhenVisibleAfterIdleMins
          ) {
            whenVisibleCallback()
          }
        }
        if (!isVisible && whenIdleCallback) {
          LOG.debug('Invisible')

          setIdleTimeout(
            setTimeout(() => {
              whenIdleCallback()
              setIdleTimeout(null)
            }, triggerAfterIdleMins * 60 * 1000)
          )
        }
      },
      [
        whenVisibleCallback,
        whenIdleCallback,
        invisibleStart,
        triggerWhenVisibleAfterIdleMins,
        triggerAfterIdleMins,
        idleTimeout
      ]
    )

    return (
      <PageVisibility onChange={handleVisibilityChange}>
        {children}
      </PageVisibility>
    )
  }
)
